import {format} from "date-fns";

export const isBlankDescription = (description?: string | null): boolean => {
    return !(description ?? "").trim();
};

const toDateKey = (value: Date | string | null | undefined): string | null => {
    if (value == null || value === "") {
        return null;
    }
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value.slice(0, 10);
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
        return null;
    }
    return format(date, "yyyy-MM-dd");
};

export const hasDepositFieldChanges = (
    submitted: {startDate?: Date | string | null; endDate?: Date | string | null; amount?: number | null},
    original: {startDate?: Date | string | null; endDate?: Date | string | null; amount?: number | null},
): boolean => {
    const startChanged = submitted.startDate != null && submitted.startDate !== ""
        && toDateKey(submitted.startDate) !== toDateKey(original.startDate);
    const endChanged = submitted.endDate != null && submitted.endDate !== ""
        && toDateKey(submitted.endDate) !== toDateKey(original.endDate);
    const amountChanged = submitted.amount != null
        && Number(submitted.amount) !== Number(original.amount);
    return startChanged || endChanged || amountChanged;
};
